import React from "react";
import { Alert, Typography, Card, Input, Divider, Descriptions } from "antd";
import { CloseCircleOutlined, FileTextOutlined } from "@ant-design/icons";

const { Text, Title, Paragraph } = Typography;
const { TextArea } = Input;

/**
 * MVT解析失败处理器组件
 * V5.0 更新：标准化处理器接口
 * 用于展示原始MVT报文及解析失败的原因
 */
const MvtParseFailedViewer = ({ actionItem, onConfirm, onReject, loading = false, readOnly = false }) => {
    // 获取处理日志和原始内容
    const processingNotes = actionItem.ai_processing_notes || "";
    const rawContent = actionItem.raw_input_content || "";

    // 从处理日志中尝试提取错误原因
    const getErrorReason = () => {
        // 常见错误模式匹配
        if (processingNotes.includes("无法解析MVT报文")) {
            return "报文格式无法识别为标准MVT格式";
        } else if (processingNotes.includes("MVT数据不完整") || processingNotes.includes("无效")) {
            return "MVT数据关键字段缺失或格式错误";
        } else if (processingNotes.includes("无法解析日期")) {
            return "航班日期格式错误或无法识别";
        } else if (processingNotes.includes("无法解析时间")) {
            return "时间格式错误或无法识别";
        } else {
            // 如果没有特定模式匹配，返回通用消息
            return "系统无法自动解析此MVT报文格式";
        }
    };

    // 渲染原始MVT报文
    const renderMvtRawContent = () => {
        if (!rawContent) return null;

        return (
            <Card
                size="small"
                title={
                    <span>
                        <FileTextOutlined /> 原始MVT报文
                    </span>
                }
                style={{ marginBottom: 16 }}
            >
                <div
                    style={{
                        fontFamily: "monospace",
                        fontSize: "14px",
                        whiteSpace: "pre-wrap",
                        background: "#f5f5f5",
                        padding: "12px",
                        borderRadius: "4px",
                        maxHeight: "150px",
                        overflowY: "auto",
                    }}
                >
                    {rawContent}
                </div>
            </Card>
        );
    };

    return (
        <div>
            {/* 错误提示 */}
            <Alert message="MVT报文解析失败" description={getErrorReason()} type="error" showIcon icon={<CloseCircleOutlined />} style={{ marginBottom: 16 }} />

            {/* 原始报文 - 直接显示 */}
            {renderMvtRawContent()}

            {/* 操作建议 */}
            <Alert
                message="操作建议"
                description={
                    <ul style={{ paddingLeft: "20px", margin: "8px 0" }}>
                        <li>请核对原始MVT报文格式是否正确</li>
                        <li>如果此报文确实包含重要信息，请考虑手动更新相关航班</li>
                        <li>可以通过"拒绝"按钮将此通知标记为已处理</li>
                    </ul>
                }
                type="info"
                showIcon
                style={{ marginBottom: 16 }}
            />

            {/* 处理日志详情 */}
            {processingNotes && (
                <Descriptions title="处理日志详情" bordered size="small" column={1}>
                    <Descriptions.Item label="AI处理过程">
                        <Paragraph
                            style={{
                                whiteSpace: "pre-line",
                                maxHeight: "200px",
                                overflow: "auto",
                            }}
                        >
                            {processingNotes}
                        </Paragraph>
                    </Descriptions.Item>
                </Descriptions>
            )}
        </div>
    );
};

export default MvtParseFailedViewer;
